import BaseTransportSummary from './BaseTransportSummary'

import type { OtherTransportItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: OtherTransportItem
}

function OtherTransportItemSummary(props: Props) {
  return <BaseTransportSummary transportName="OtherTransport" {...props} />
}

export default OtherTransportItemSummary
